const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexGrow: 1,
    textAlign: 'center',
  },

  connectedIcon: {
    marginRight: '5px',
    height: '14px',
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& > span': {
      fontWeight: 500,
    },
  },

  dottedLogo: {
    borderRadius: 6,
    width: 60,
    height: 60,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px dashed #e1e9f0',
    marginBottom: '15px',
  },

  break: {
    border: '0.5px solid #e1e9f0',
    width: '300px',
    margin: '0 0 23px',
    marginTop: '30px',
    marginBottom: '30px',
  },

  detail: {
    marginTop: '20px',
  },

  detailDescription: {
    fontSize: '14px',
    color: '#7b8b99',
    marginBottom: '10px',
  },

  detailValue: {
    fontSize: '15px',
    color: '#27282a',
    fontWeight: 500,
  },

  detailExtra: {
    fontSize: '14px',
    color: '#596168',
  },
});

export default styles;
